export default "__VITE_ASSET__CAlyagb1__"